  <div class="glass-card bg-dark border-3 rounded-4 p-4 h-100 d-none">

    <!-- HEADER -->
    <h5 class=" mb-4 text-warning">
      Security, Demographics &amp; Competition
    </h5>

    <!-- TOP META - Now Dynamic -->
    <div class="row small mb-3">
      <div class="col-md-6 mb-2">
        <p class="mb-1 text-white">Area Crime Index (Relative)</p>
        <p class="mb-0  text-warning">
          {{ crimeStats.crimeIndex || 'Unknown' }} RISK 
          <span class="text-danger" v-if="crimeStats.precinct">({{ crimeStats.precinct }})</span>
        </p>
      </div>
      <div class="col-md-6 mb-2" v-if="crimeStats.periodIncrease">
        <p class="mb-1 text-white">Trend Analysis</p>
        <p class="mb-0 " :class="crimeStats.periodIncrease.includes('increase') ? 'text-danger' : 'text-success'">
          {{ crimeStats.periodIncrease }}
        </p>
      </div>
      <div class="col-md-6 mb-2" v-if="crimeStats.stationContact">
        <p class="mb-1 text-white">Police Contact</p>
        <p class="mb-0  text-info">{{ crimeStats.stationContact }}</p>
      </div>
      <div class="col-md-6 mb-2" v-if="crimeStats.lastUpdated">
        <p class="mb-1 text-white">Last Updated</p>
        <p class="mb-0  text-white-50">{{ crimeStats.lastUpdated }}</p>
      </div>
    </div>

    <!-- INCIDENTS HEADER - Now Dynamic -->
    <p class="small text-muted mb-2">
      {{ crimeStats.precinct || 'Local' }} Crime Statistics
      <span v-if="crimeStats.lastUpdated">(Last Updated: {{ crimeStats.lastUpdated }})</span>
    </p>

    <!-- INCIDENT LIST - Now Dynamic -->
    <div class="d-flex flex-column gap-2 overflow-auto" style="max-height: 170px;">
      <div
        v-for="incident in dynamicIncidents"
        :key="incident.id"
        class="d-flex align-items-stretch rounded-3 bg-secondary bg-opacity-25"
      >
        <!-- LEFT SEVERITY STRIP -->
        <div
          class="border-start border-4 rounded-start-3"
          :class="{
            'border-danger': incident.severity === 'critical',
            'border-warning': incident.severity === 'high',
            'border-info': incident.severity === 'info'
          }"
        ></div>

        <!-- MAIN CONTENT -->
        <div class="flex-grow-1 px-3 py-2">
          <p class="mb-1  text-white small">
            {{ incident.title }}
          </p>
          <div class="d-flex justify-content-between align-items-center">
            <p class="mb-0 text-white-50 small">
              {{ incident.timestamp }}
            </p>
            <p class="mb-0 small" :class="{
              'text-success': incident.status === 'Analyzed',
              'text-warning': incident.status === 'Pending',
              'text-info': incident.status === 'No Data'
            }">
              {{ incident.status }}
            </p>
          </div>
          <!-- Trend indicator -->
          <div v-if="incident.trend" class="mt-1">
            <span class="badge" :class="{
              'bg-success': incident.trend.startsWith('-'),
              'bg-danger': incident.trend.startsWith('+'),
              'bg-secondary': incident.trend === '0%'
            }">
              Trend: {{ incident.trend }}
            </span>
          </div>
        </div>

        <!-- RIGHT ACCENT STRIP -->
        <div class="border-end border-4 border-info rounded-end-3"></div>
      </div>
    </div>

    <!-- Summary Footer -->
    <div v-if="crimeStats.incidentSummary && crimeStats.incidentSummary.length > 0" class="mt-3 pt-2 border-top border-secondary">
      <p class="small text-muted mb-1">Total Incidents: 
        <span class="text-warning ">
          {{ crimeStats.incidentSummary.reduce((sum, crime) => sum + crime.count, 0) }} cases
        </span>
      </p>
    </div>

  </div>